import { Routes } from '@angular/router';
import { VocabularyDashboardComponent } from './components/vocabulary-dashboard.component';
import { ConceptWorkspaceComponent } from "./components/concept-workspace.component";

export const vocabularyRoutes: Routes = [
  {
    path: 'vocabulary-dashboard/:key',
    component: VocabularyDashboardComponent,
    data: {
      permissions: ['VocabularyModule.CodeSystem:View']
    }
  },
  {
    path: 'concept-workspace/:key',
    component: ConceptWorkspaceComponent,
    data: {
      permissions: ['VocabularyModule.CodeSystem:View']
    }
  }
];



// WEBPACK FOOTER //
// ./src/app/vocabulary/routes.config.ts